exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  font-family: 'Roboto', sans-serif !important;\n  background-color: #2A8FBD !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/linusvaltersson/AtomizeSource/clean_web/atomize-interest/node_modules/css-loader?{"sourceMap":false,"import":false}!/Users/linusvaltersson/AtomizeSource/clean_web/atomize-interest/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Users/linusvaltersson/AtomizeSource/clean_web/atomize-interest/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/Users/linusvaltersson/AtomizeSource/clean_web/atomize-interest/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = styles